<template>
    <div class="page">
        <el-backtop><i class="el-icon-caret-top"></i></el-backtop>
        <img src="../../assets/images/product/xnr-til.png" alt="" srcset="" class="til">
        <img src="../../assets/images/wenli-3.png" alt="" srcset="" class="wl3">
        <div class="cons">
            <img src="../../assets/images/product/xnr1.jpg" alt="" srcset="">
            <img src="../../assets/images/product/xnr2.png" alt="" srcset="">
            <img src="../../assets/images/product/xnr3.jpg" alt="" srcset="">
            <img src="../../assets/images/product/xnr4.png" alt="" srcset="">
            <img src="../../assets/images/product/xnr5.jpg" alt="" srcset="">
            <img src="../../assets/images/product/xnr6.png" alt="" srcset="">
            <img src="../../assets/images/product/xnr7.jpg" alt="" srcset="">
            <img src="../../assets/images/product/xnr8.jpg" alt="" srcset="">
            <img src="../../assets/images/product/xnr9.jpg" alt="" srcset="">
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
        }
    },
    created(){
    },
    methods: {
    }
    
}
</script>
<style lang="scss" scoped>
.page{
    background: #F8F9FA;
    position: relative;
    // display: inline-block;
    // width: 100%;
    .til{
        width: 229px;
        height: 156px;
        position: absolute;
        top: 104px;
        left: 138px;
        z-index: 1;
    }
    .wl3{
        width: 1146px;
        height: 1043px;
        position: absolute;
        top: 0;
        left: 0;
    }
    .cons{
        width: 1082px;
        margin-top: 104px;
        margin-left: 656px;
        margin-bottom: 72px;
        img{
            width: 100%;
            display: block;
        }
    }
}
</style>